import type { TextDto } from "@babackapp/private-api-client";

export function pickLocalizedText(texts: TextDto[], lang: string): string | null {
  const langPrefix = lang.split("-")[0].toLowerCase();
  const match =
    texts.find((t) => t.lang.toLowerCase() === lang.toLowerCase()) ??
    texts.find((t) => t.lang.toLowerCase().startsWith(langPrefix)) ??
    texts[0];
  const text = match?.text?.trim();
  if (!text || text === "<p></p>" || text === "<p><br></p>") return null;
  return text;
}
